import { safeApiRequest } from './apiClient';

const ADDRESSES_ENDPOINT = '/api/customers';

/**
 * Müşteri adreslerini listeler
 * @param {string} customerId - Müşteri ID
 * @param {boolean} aktif - Sadece aktif adresleri getir (opsiyonel)
 * @returns {Promise<Object>}
 */
export const fetchAddressesByCustomer = async (customerId, aktif = null) => {
  if (!customerId) {
    throw new Error('Müşteri ID gereklidir');
  }

  const query = {};
  if (aktif !== null) {
    query.aktif = aktif;
  }

  const response = await safeApiRequest(
    `${ADDRESSES_ENDPOINT}/${customerId}/addresses`,
    {
      method: 'GET',
      query,
    }
  );

  return response;
};

/**
 * Yeni adres ekler
 * @param {string} customerId - Müşteri ID
 * @param {Object} addressData - Adres bilgileri
 * @param {string} addressData.adres - Adres metni
 * @param {string} addressData.cityId - İl ID
 * @param {string} addressData.districtId - İlçe ID
 * @param {boolean} addressData.varsayilan - Varsayılan adres mi?
 * @param {boolean} addressData.aktif - Aktif mi?
 * @returns {Promise<Object>}
 */
export const createAddress = async (customerId, addressData) => {
  if (!customerId) {
    throw new Error('Müşteri ID gereklidir');
  }

  if (!addressData.adres || addressData.adres.trim() === '') {
    throw new Error('Adres gereklidir');
  }

  const payload = {
    adres: String(addressData.adres).trim(),
    varsayilan: addressData.varsayilan === true,
    aktif: addressData.aktif !== false, // Default: true
  };

  // İl ve ilçe bilgilerini ekle
  if (addressData.cityId) {
    payload.cityId = addressData.cityId;
  }

  if (addressData.districtId) {
    payload.districtId = addressData.districtId;
  }

  const response = await safeApiRequest(
    `${ADDRESSES_ENDPOINT}/${customerId}/addresses`,
    {
      method: 'POST',
      body: payload,
    }
  );

  return response;
};

/**
 * Adres günceller
 * @param {string} customerId - Müşteri ID
 * @param {string} addressId - Adres ID
 * @param {Object} addressData - Güncellenecek adres bilgileri
 * @param {string} addressData.adres - Adres metni
 * @param {string} addressData.cityId - İl ID (opsiyonel)
 * @param {string} addressData.districtId - İlçe ID (opsiyonel)
 * @param {boolean} addressData.varsayilan - Varsayılan adres mi?
 * @param {boolean} addressData.aktif - Aktif mi?
 * @returns {Promise<Object>}
 */
export const updateAddress = async (customerId, addressId, addressData) => {
  if (!customerId) {
    throw new Error('Müşteri ID gereklidir');
  }

  if (!addressId) {
    throw new Error('Adres ID gereklidir');
  }

  if (!addressData.adres || addressData.adres.trim() === '') {
    throw new Error('Adres gereklidir');
  }

  const payload = {
    adres: String(addressData.adres).trim(),
  };

  // İl ve ilçe bilgilerini ekle
  if (addressData.cityId) {
    payload.cityId = addressData.cityId;
  }

  if (addressData.districtId) {
    payload.districtId = addressData.districtId;
  }

  if (addressData.varsayilan !== undefined) {
    payload.varsayilan = addressData.varsayilan === true;
  }

  if (addressData.aktif !== undefined) {
    payload.aktif = addressData.aktif === true;
  }

  const response = await safeApiRequest(
    `${ADDRESSES_ENDPOINT}/${customerId}/addresses/${addressId}`,
    {
      method: 'PUT',
      body: payload,
    }
  );

  return response;
};

/**
 * Adres siler (soft delete - aktif: false yapar)
 * @param {string} customerId - Müşteri ID
 * @param {string} addressId - Adres ID
 * @returns {Promise<Object>}
 */
export const deleteAddress = async (customerId, addressId) => {
  if (!customerId) {
    throw new Error('Müşteri ID gereklidir');
  }

  if (!addressId) {
    throw new Error('Adres ID gereklidir');
  }

  const response = await safeApiRequest(
    `${ADDRESSES_ENDPOINT}/${customerId}/addresses/${addressId}`,
    {
      method: 'DELETE',
    }
  );

  return response;
};

/**
 * Adresi varsayılan yapar
 * @param {string} customerId - Müşteri ID
 * @param {string} addressId - Adres ID
 * @returns {Promise<Object>}
 */
export const setDefaultAddress = async (customerId, addressId) => {
  if (!customerId) {
    throw new Error('Müşteri ID gereklidir');
  }

  if (!addressId) {
    throw new Error('Adres ID gereklidir');
  }

  const response = await safeApiRequest(
    `${ADDRESSES_ENDPOINT}/${customerId}/addresses/${addressId}/set-default`,
    {
      method: 'PATCH',
    }
  );

  return response;
};


